import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import '../Callback.scss'

class AccessDenied extends Component {
  render() {
    const mailText = encodeURIComponent("Bonjour,\nVeuillez trouvez ci-dessous les sites à ajouter à notre périmètre :\n\n\nRaison sociale:\nN° de point de livraison:\n\n\n");
    const mailTo = `mailto:vinci-access@eleneo.fr?subject=Demande d'accès Eleneo eSite&body=${mailText}`

    return (
      <div className="callback-container">
        <h5>Vos accès ne sont pas paramétrés.</h5>
        <h5>Veuillez indiquer la raison sociale , N° de point de livraison du ou des sites</h5>
        <h5>pour lesquels vous demandez un accès au portail de suivi des consommations groupe VINCI</h5>
        <p>
          <a href={mailTo}>Cliquez ici pour contacter votre administrateur des droits</a>
        </p>
      </div>
    )
  }
}

export default withTranslation()(AccessDenied)
